class MFooter extends HTMLElement {
  constructor() {
    super();
    this.onMatchMobile = () => this.setupAccordion(true);
    this.onUnmatchMobile = () => this.setupAccordion(false);
    this.syncAccordionState = this.syncAccordionState.bind(this);
  }

  connectedCallback() {
    this.mobileAccordion = this.querySelector(".m-footer--accordion");
    this.mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");
    this.items = Array.from(this.querySelectorAll(".m-footer--accordion .m-accordion--item"));
    this.items.forEach((item) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");
      if (button && content) {
        content.id = content.id || `FooterContent-${item.dataset.footerBlockId}`;
        button.setAttribute("aria-controls", content.id);
      }
    });
    this.observer = new MutationObserver(this.syncAccordionState);
    this.observer.observe(this, { attributes: true, attributeFilter: ["class"], subtree: true });
    document.addEventListener("matchMobile", this.onMatchMobile);
    document.addEventListener("unmatchMobile", this.onUnmatchMobile);
    this.setupAccordion(Boolean(MinimogTheme.config.mqlMobile));
  }

  disconnectedCallback() {
    document.removeEventListener("matchMobile", this.onMatchMobile);
    document.removeEventListener("unmatchMobile", this.onUnmatchMobile);
    this.observer && this.observer.disconnect();
    this.destroyAccordion();
    this.isMobile = false;
    this.syncAccordionState();
  }

  destroyAccordion() {
    if (this.acc) {
      this.acc.destroy();
      this.acc = null;
      this.mobileAccordion.classList.remove("acc-initialized");
    }
  }

  setupAccordion(mobile) {
    if (!this.isConnected) return;
    this.isMobile = mobile;
    if (this.mobileAccordion) {
      if (mobile && !this.acc) {
        // Keep focus usable if the layout changes while a footer link is focused.
        this.items.forEach((item) => {
          const content = item.querySelector(".m-accordion--item-content");
          if (content && content.contains(document.activeElement)) item.classList.add("open");
        });
        this.acc = new MinimogLibs.Accordion(this.mobileAccordion, { presetContentHeight: false });
        this.acc.setContentHeight();
      } else if (!mobile) {
        this.destroyAccordion();
      }
    }
    this.syncAccordionState();
    if (this.mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${this.mobileStickyBar.offsetHeight}px`);
    }
  }

  syncAccordionState() {
    (this.items || []).forEach((item) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");
      if (!button || !content) return;
      const expanded = !this.isMobile || item.classList.contains("open");
      button.disabled = !this.isMobile;
      button.setAttribute("aria-expanded", String(expanded));
      content.inert = !expanded;
      if (expanded) content.removeAttribute("aria-hidden");
      else content.setAttribute("aria-hidden", "true");
    });
  }
}
customElements.define("m-footer", MFooter);
